import { render, staticRenderFns } from "./GlobalFormulaCalculator.vue?vue&type=template&id=6bca227a&scoped=true&"
import script from "./GlobalFormulaCalculator.vue?vue&type=script&lang=js&"
export * from "./GlobalFormulaCalculator.vue?vue&type=script&lang=js&"
import style0 from "./GlobalFormulaCalculator.vue?vue&type=style&index=0&id=6bca227a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bca227a",
  null
  
)

export default component.exports